import { common as frCommon } from './fr/common';
import { common as enCommon } from './en/common';

const messages = {
  fr: {
    translation: frCommon
  },
  en: {
    translation: enCommon
  }
};

export default messages;
